import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    brand: {
      50: '#fffbeb',  // amber-50
      100: '#fef3c7', // amber-100
      200: '#fde68a', // amber-200
      300: '#fcd34d', // amber-300
      400: '#fbbf24', // amber-400 (primary)
      500: '#f59e0b', // amber-500 (hover)
      600: '#d97706', // amber-600
      700: '#b45309', // amber-700
      800: '#92400e', // amber-800
      900: '#78350f', // amber-900
    },
    mgc: {
      // MGC-specific brand colors
      gold: '#bb9446',
      warmGray: '#f5f5f4',
    },
  },
  fonts: {
    heading: 'Inter, system-ui, sans-serif',
    body: 'Inter, system-ui, sans-serif',
  },
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  styles: {
    global: {
      body: {
        bg: 'white',
        color: 'gray.900',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '600',
        borderRadius: 'lg',
      },
      variants: {
        solid: {
          bg: 'brand.400',
          color: 'gray.900',
          _hover: {
            bg: 'brand.500',
            transform: 'translateY(-1px)',
            shadow: 'lg',
          },
          _active: {
            transform: 'translateY(0)',
          },
          transition: 'all 0.2s',
        },
      },
      defaultProps: {
        colorScheme: 'brand',
      },
    },
    Input: {
      variants: {
        outline: {
          field: {
            borderColor: 'gray.300',
            _focus: {
              borderColor: 'brand.400',
              boxShadow: '0 0 0 3px rgba(251, 191, 36, 0.1)',
            },
          },
        },
      },
    },
    Tab: {
      baseStyle: {
        fontWeight: '500',
        _selected: {
          color: 'brand.700',
          borderColor: 'brand.500',
        },
      },
    },
  },
});

export default theme;
